import { ScheduleItemMainExtra } from "slot-definitions"
import { Chip } from "@mui/material"
import { useIsRetired } from "lib/@hooks/use-is-retired"

ScheduleItemMainExtra.plug(<RetiredChip />)

export function RetiredChip() {
    const isRetired = useIsRetired()
    return isRetired && <Chip data-cy="retired-chip" size="small" sx={{ mx: 1 }} label="Retired" />
}
